import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Book } from '../models/book';
import { BookFactory } from '../models/factories/book-factory';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class BookService {

    usedBooks: any;

    constructor(private applicationStateService: ApplicationStateService,
                private crudService: CrudService) {
    }

    getUsedBooks(): Promise<Array<Book>> {

        if (!this.applicationStateService.userData.loggedIn) {
            return new Promise<Array<Book>>(resolve => {
                this.usedBooks = [];
                resolve([]);

                return;
            });
        }

        if (this.usedBooks) {
            return new Promise<Array<Book>>(resolve => {
                resolve(this.usedBooks as Array<Book>);
            });
        }

        return new Promise(resolve => {
            this.crudService.getAllEntities(Book, new BookFactory(), {})
                .then(result => {
                    this.usedBooks = result;
                    resolve(result as Array<Book>);
                });
        });
    }
}
